<template>
  <v-chip color="grey lighten-3" close @click:close="close">
    <v-avatar v-if="filter.icon === 'progress_full' || filter.icon === 'progress_empty'" left>
      <v-progress-circular :rotate="-90" :size="28" :width="2" :value="progressValue" :color="progressColour">
        {{ progressValue }}
      </v-progress-circular>
    </v-avatar>
    <v-icon left v-else>{{ filter.icon }}</v-icon>
    <strong>{{ filter.text }}</strong>
  </v-chip>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'nullable-filter-chip',
  props: ['filter'],
  computed: {
    ...mapGetters(['CustomerPageFilters']),
    progressValue: function() {
      return this.filter.icon === 'progress_full' ? 100 : 0;
    },
    progressColour: function() {
      return this.filter.icon === 'progress_full' ? 'accent' : 'grey';
    }
  },
  methods: {
    ...mapActions(['setCustomerPageFilters', 'getCustomerPage']),
    close() {
      this.setCustomerPageFilters({ [this.filter.value]: null }).then(() => this.getCustomerPage());
    }
  }
};
</script>

<style lang="scss" scoped>
div.input-group {
  padding-top: 0;
}
::v-deep .input-group__details {
  display: none;
}
</style>
